import React from 'react';
import type { ChipTint } from '@/utils/builderChipColors';
import styles from './BuilderChip.module.scss';

interface BuilderChipProps {
  tint: ChipTint;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  title?: string;
}

/** Small pill chip matching the reference design's `.chip` — used for competency/type/question-set tags. */
export const BuilderChip: React.FC<BuilderChipProps> = ({ tint, children, onClick, title }) => (
  <span
    className={`${styles.chip} ${styles[`tint-${tint}`]} ${onClick ? styles.clickable : ''}`}
    onClick={onClick}
    title={title}
  >
    {children}
  </span>
);

export default BuilderChip;
